import { useState } from 'react'
import { lumi } from '@/lib/lumi'

interface ProfilePhoto {
  _id: string
  imageUrl: string
  creator: string
  createdAt: string
  updatedAt: string
}

export function useProfilePhoto() {
  const [photo, setPhoto] = useState<ProfilePhoto | null>(null)
  const [loading, setLoading] = useState(false)

  const fetchPhoto = async () => {
    try {
      setLoading(true)
      const result = await lumi.entities.profilePhoto.list()
      if (result?.list && result.list.length > 0) {
        setPhoto(result.list[0] as ProfilePhoto)
      }
    } catch (error) {
      console.error('Error fetching profile photo:', error)
    } finally {
      setLoading(false)
    }
  }

  const uploadPhoto = async (imageUrl: string) => {
    try {
      // Delete existing photo first
      const existing = await lumi.entities.profilePhoto.list()
      if (existing?.list && existing.list.length > 0) {
        for (const item of existing.list) {
          await lumi.entities.profilePhoto.delete(item._id)
        }
      }

      // Create new photo
      const newPhoto = await lumi.entities.profilePhoto.create({
        imageUrl,
        creator: 'admin'
      })
      setPhoto(newPhoto as ProfilePhoto)
      return newPhoto
    } catch (error) {
      console.error('Error uploading photo:', error)
      throw error
    }
  }

  const deletePhoto = async () => {
    try {
      if (photo?._id) {
        await lumi.entities.profilePhoto.delete(photo._id)
        setPhoto(null)
      }
    } catch (error) {
      console.error('Error deleting photo:', error)
      throw error
    }
  }

  return {
    photo,
    loading,
    fetchPhoto,
    uploadPhoto,
    deletePhoto
  }
}
